<template>
    <p>Are you sure you want to delete this Payout Event?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import type { IPayoutEvent } from '../../models/PayoutEvent.ts';
import { usePayoutEventRepository } from '../../repositories/usePayoutEventRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<IPayoutEvent>,
        required: true,
    },
});

const destroy = usePayoutEventRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
